










import { Component, Vue } from 'vue-property-decorator';
import VueI18n from 'vue-i18n'

@Component
export default class LanguageSelect extends Vue {
  switchLocale(locale: VueI18n.Locale): void {
    this.$i18n.locale = locale
  }

  get locale(): VueI18n.Locale {
    return this.$i18n.locale
  }

  get locales(): VueI18n.Locale[] {
    return this.$i18n.availableLocales
  }
}
